import type { B2bGateOrderResource } from "@exonn/js-sdk";

import { useOne, type UseOneQueryOptions } from "src/system/useOne.tsx";
import { ResourceEnum } from "src/constants/constants.ts";

export const useExonnHubOrder = ({
  orderId,
  queryOptions,
}: {
  orderId: string;
  queryOptions?: UseOneQueryOptions<B2bGateOrderResource>;
}) => {
  const { data, ...restQuery } = useOne<B2bGateOrderResource>({
    resource: ResourceEnum.B2bGateOrder,
    id: orderId,
    lang: "de",
    queryOptions,
  });

  return {
    ...restQuery,
    data: data ? mapToCart(data.data) : undefined,
  };
};

const mapToCart = (order: B2bGateOrderResource) => {
  const positions = (order.b2b_gate_supplier_orders || []).flatMap(
    (order) => order.b2b_gate_supplier_order_positions || [],
  );
  return {
    items: positions.map((item) => ({
      supplierId: item.b2b_gate_supplier_order!.supplier_id,
      supplierName: item.b2b_gate_supplier_order!.supplier!.name || "",
      title: item.variant_title,
      small_image: item.small_image,

      big_image: item.big_image,
      productId: item.variant_id,
      unitPrice: +item.unit_price,
      id: item.id,
      sku: item.variant_sku,
      variantId: item.variant_id,
      total: +item.total_price,
      quantityInPackages:
        +item.quantity_order / +(item.amount_of_unit_per_package || 1),
      amountPerPackage: +(item.amount_of_unit_per_package || 1),
    })),
    supplierQuantity: 1, // not used anymore
    totalQuantity: positions.length,
    total: +(order.total_price || 0),
  };
};
